import icon from './icon.svg'
import { mapFlags } from '~/utils/features'

export default {
  computed: {
    ...mapFlags({
      visible: { flag: 'appointments' }
    })
  },
  data: () => ({
    icon,
    title: 'Appointments',
    subtitle: 'Manage your appointments'
  })
}
